import Bb from '../../../config/backbone'
import dispatcher from '../../../dispatcher'

const Player = Bb.Model.extend({
  defaults:{
    name:'',
    image:'',
    scoreBoard: []
  },
  initialize(){
    Bb.Model.prototype.initialize.apply(this, arguments)
    this.listenTo(this, 'change', ()=>{ dispatcher.emit('players:changed')})
  }
})

const Players = Bb.Collection.extend({
  model: Player,
  initialize(){
    Bb.Collection.prototype.initialize.apply(this, arguments)
    this.listenTo(this, 'remove add', ()=>{ dispatcher.emit('players:changed')})
  }
})


export default Players







// WEBPACK FOOTER //
// ./src/game/players/collection/Player.js